module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_02-tablet-e09b6c6a2565edd1938938c151d2c9ce.jpg";